export enum Gender {
    MALE = "Male",
    FEMALE = "Female",
    // BOTH = "Other",
}

export enum Type_Time {
    TRAINEE = "Trainee",
    FULL_TIME = "FullTime",
}

export enum Relation_Type {
    FATHER = 'Father',
    MOTHER = 'Mother',
    SPOUSE = 'Spouse',
    CHILD = 'Child',
    GUARDIAN = 'Guardian',
    SIBLING = 'Sibling'
}

export enum Status {
    ACTIVE = "Active",
    IN_ACTIVE = "In Active"
}

export enum Search_Asset_Allocation_Status {
    ALLOCATED = "Allocated",
    MISSING = "Missing",
}

export enum Search_Asset_Request_Status {
    REQUESTED = "Requested",
    REQUEST_CANCELLED = "Request Cancelled",
    REQUEST_REJECTED = "Request Rejected",
    REQUEST_ACCEPTED = "Request Accepted"
}

export enum Asset_Status {
    IN_STOCK = "In Stock",
    IN_USE = "In Use",
    UNDER_MAINTENANCE = "Under Maintenance",
    MISSING = "Missing",
    DISPOSED = "Disposed",
}

export enum Policy_Status {
    DRAFT = "Draft",
    PUBLISHED = "Published",
    UN_PUBLISHED = "Unpublished",
}

export enum Return_Asset_Status {
    IN_STOCK = "In Stock",
    DISPOSED = "Disposed",
    UNDER_MAINTENANCE = "Under Maintenance",
}

export enum Employee_Sort_Field {
    employeeCode = "EMPLOYEE_CODE",
    firstName = "NAME",
    officialEmail = "OFFICIAL_EMAIL", // adjust if needed
    joiningDate = "JOINING_DATE"
}

export enum Leave_Entitlement_Field {
    firstName = 'EMPLOYEE_NAME',
    leaveType = 'LEAVE_TYPE',
    unit = 'UNIT',
    createdOn = 'CREATED_ON'
}

export enum Attendance_Sort_Field {
    firstName = 'EMPLOYEE_FIRST_NAME',
    employeeCode = 'EMPLOYEE_CODE',
    date = 'DATE',
    status = 'STATUS',
    createdOn = 'CREATED_ON'
}

export enum Leave_Request_Field {
    date = 'DATE',
    leaveType = 'LEAVE_TYPE',
    state = 'STATE',
    createdOn = 'CREATED_ON'
}

export enum User_Sort_Field {
    firstName = 'FIRST_NAME',
    email = 'EMAIL',
    createdOn = 'CREATED_ON',
    active = 'ACTIVE'
}

export enum Asset_Allocation_Sort_Field {
    assignedDate = 'ASSIGNED_DATE',
    expectedReturnDate = 'EXPECTED_RETURN_DATE',
    createdOn = 'CREATED_ON'
}

export enum Asset_Status_Update {
    UNDER_MAINTENANCE = "Under Maintenance",
    DISPOSED = "Disposed",
}

export const STATUS_TRANSITIONS_RULES: Record<string, string[]> = {
    IN_STOCK: ["MISSING", "DISPOSED", "UNDER_MAINTENANCE"],
    IN_USE: [],
    UNDER_MAINTENANCE: ["IN_STOCK", "MISSING", "DISPOSED"],
    MISSING: ["IN_STOCK", "DISPOSED", "UNDER_MAINTENANCE"],
    DISPOSED: [],
};

export enum Designation {
    TRAINEE = "Trainee",
    JUNIOR_SOFTWARE_DEVELOPER = "Jr Software Developer",
    SOFTWARE_DEVELOPER = "Software Developer",
    SENIOR_SOFTWARE_DEVELOPER = "Sr Software Developer",
    TECHNICAL_LEAD = "Technical Lead",
    ASSOCIATE_SOFTWARE_DEVELOPER = "Associate Software Developer"
}

export enum Marital_Status {
    MARRIED = "Married",
    UNMARRIED = "Unmarried",
    DIVORCED = "Divorced",
    WIDOWED = "Widowed",
    WIDOWER = "Widower",
    SEPARATED = "Seperated",
    OTHER = "Other"
}

export enum Blood_Group {
    AB_POSITIVE = "AB+",
    AB_NEGATIVE = "AB-",
    A_POSITIVE = "A+",
    A_NEGATIVE = "A-",
    B_POSITIVE = "B+",
    B_NEGATIVE = "B-",
    O_POSITIVE = "O+",
    O_NEGATIVE = "O-",
    NONE = "N.A."
}

export enum Document_Type {
    BANK_STATEMENT = "Bank Statement",
    RATION_CARD = "Ration Card",
    CERTIFICATE = "Training Certificate",
    HSC = "10th Marksheet",
    SSC = "12th Marksheet",
    UG = "UG",
    PG = "PG",
    OFFER_LETTER = "Offer Letter",
    APPOINTMENT_LETTER = "Appointment Letter",
    APPRAISAL_LETTER = "Appraisal Letter",
    PROMOTION_LETTER = "Promotion Letter",
    PREVIOUS_EXPERIENCE_LETTER = "Previous Experience Letter",
    JOINING_FORM = "Joining Letter",
    RESIGNATION_LETTER = "Resignation Letter",
    RELIEVING_LETTER = "Relieving Letter",
    NO_DUES_CLEARANCE = "No dues clearance",
    BANK_ACCOUNT_PROOF = "Bank Account",
    INCOME_TAX_RETURN = "Incone tax return",
    AADHAAR_CARD = "Aadhaar Card",
    PAN_CARD = "Pan Card",
    PASSPORT = "Passport",
    VOTER_ID = "Voter Id",
    DRIVING_LICENSE = "Driving License",
    POLICY = "Policy",
    PROFILE_PHOTO = "Profile Photo",
    PASSPORT_PHOTO = "Passport Photo",
    SIGNATURE_PHOTO = "Signature Photo",
    BIRTHDAY_PHOTO = "Birthday",
    WORK_ANNIVERSARY_PHOTO = "Work anniversary",
    EVENT_PHOTO = "Event Photo",
    TRAINING_PHOTO = 'Training Photo',
    ACHIEVEMENT_PHOTO = "Achievement Photo",
    SALARY_SLIP = "Salary Slip",
    FORM_16 = "Form 16",
    OTHERS = "Others",
    MEMORIES = "Memories"
}


export enum User_type {
    EMPLOYEE = "Employee",
    ADMIN = "Admin",
    // HR = "Hr"
}

export enum User_title {
    MR = "Mr",
    MS = "Ms",
    MRS = "Mrs",
}

export enum Holiday_Type {
    NATIONAL_HOLIDAY = "National Holiday",
    MANDATORY = "Mandatory Holiday",
    OPTIONAL = "Optional Holiday",
    RESTRICTED = "Restricted Holiday",
    EMERGENCY = "Emergency Holiday",
}

export enum Holiday_Status {
    FULL_DAY = "Full Day",
    HALF_DAY = "Half Day"
}

export enum Leave_Type_Status {
    WORKING = "Working",
    WEEKEND = "Weekend"
}

export enum Leave_Type {
    GENERAL_LEAVE = "General Leave",
    // CASUAL_LEAVE = "Casual Leave",
    // SICK_LEAVE = "Sick Leave",
    // PATERNITY_LEAVE = "Paternity Leave",
    // MATERNITY_LEAVE = "Maternity Leave",
    // MARRIAGE_LEAVE = "Marriage Leave",
    // BEREAVEMENT_LEAVE = "Bereavement Leave",
}

export enum Paid_Type {
    PAID = "Paid",
    UN_PAID = "Un Paid"
}


export enum Week_Days {
    MONDAY = "Monday",
    TUESDAY = "Tuesday",
    WEDNESDAY = "Wednesday",
    THURSDAY = "Thursday",
    FRIDAY = "Friday",
    SATURDAY = "Saturday",
    SUNDAY = "Sunday"
}

export enum Leave_Status {
    PENDING = "Pending",
    APPROVED = "Approved",
    REJECTED = "Rejected",
    CANCELLED = "Cancelled",
}

export enum Leave_Duration {
    FULL_DAY = "Full Day",
    FIRST_HALF = "First Half",
    SECOND_HALF = "Second Half"
}

export enum Event_Type {
    BIRTHDAY = 'Birthdays',
    CUSTOM_EVENT = 'Events',
    WORK_ANNIVERSARY = 'Work Anniversary',
    TRAINING = 'Trainings',
}

export enum Event_State {
    CREATED = "Created",
    CONFIRMED = "Confirmed",
    FINISHED = "Finished",
    CANCELLED = "Cancelled"
}

export enum Qualification {
    BTECH = "B.Tech",
    MTECH = "M.Tech",
    BCA = "BCA",
    MCA = "MCA",
    BSC_IT = "B.Sc IT",
    MSC_IT = "M.Sc IT",
    BE = "BE",
    MBA = "MBA"
}

export enum PollAndVote {
    POLL = "Poll",
    VOTE = "Vote",
}